import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import "reset.css";
import "./index.scss";
import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import "leaflet/dist/leaflet.css";
import "leaflet/dist/leaflet";
import "@splidejs/react-splide/css/core";

import reportWebVitals from "./reportWebVitals";
import App from "./App.tsx";
import store from "./store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
